enum RegistersTabs {
  SUMMARY = 'summary',
  IPAD_AIR = 'ipad-air',
  IPAD_MINI = 'ipad-mini',
  RECEIPT_PRINTER = 'receipt-printer',
  PAYMENT_TERMINAL = 'payment-terminal',
  ANOMALIES = 'anomalies',
}

export default RegistersTabs;
